// OAWeekHero.tsx
import React from "react";

const OAWeekHero: React.FC = () => {
  return (
    <section className="relative isolate h-[520px] md:h-screen w-full overflow-hidden">
      {/* Background image */}
      <img
        src="/assets/images/backgrounds/group-of-black-students-hanging-out-with-laptops.png"
        alt="Students collaborating on a laptop outdoors"
        className="absolute inset-0 -z-10 h-full w-full object-cover object-center"
      />

      {/* Blue tint like the mock */}
      <div className="absolute inset-0 -z-10 bg-sky-700/45 mix-blend-multiply" />

      {/* Gentle dark gradient for legibility (not too strong) */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-black/10 via-black/20 to-black/30" />

      {/* Content block centered vertically (and left aligned) */}
      <div className="relative z-10 mx-auto h-full max-w-6xl px-4">
        <div className="flex h-full items-center">
          <div className="text-white drop-shadow-[0_1px_1px_rgba(0,0,0,0.6)] text-center">
            <h1 className="max-w-xxxxl text-xxxxl font-bold leading-tight tracking-tight md:text-xxxxl">
              LIBSENSE Marks International Open Access Week 2025
            </h1>
            <p className="mt-4 max-w-xxxxl text-base italic text-white/95 md:text-xl">
              Celebrating openness, equity, and community-driven scholarship in Africa
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OAWeekHero;
